<div class="select-field" [ngClass]="{'select-field--no-margin' : showCustom}">
    <!-- Drop Down Button -->
    <div 
        *ngIf="!showCustom"
        class="select-field__btn-container"
        [ngClass]="{
            'select-field__btn-container--error' : hasError,
            'select-field__btn-container--disabled' : disabled
        }"
    >
        <!-- Placeholder text on selected option -->
        <div class="select-field__btn-container__placeholder" *ngIf="optionExists">
            {{ placeholder }}
        </div>
        <!-- Button for creating dropdown -->
        <button
            mat-button
            type="button"
        class="select-field__btn-container__btn"
            (click)="toggleOptions()"
            [disableRipple]="true"
            [disabled]="disabled"
            [ngClass]="{
                'select-field__btn-container__selected' : optionExists,
                'select-field__btn-container__btn--disabled' : disabled,
                'select-field__btn-container__btn--error' : hasError
            }"
        >
            {{ label }}
            <!-- Downward Purple Arrow -->
            <div 
                class="arrow" 
                [ngClass]="{
                    'arrow--error' : hasError,
                    'arrow--up' : showOptions,
                    'arrow--disabled' : disabled
                }"
            ></div>
        </button>
    </div>
    <!-- Drop Down Custom Input Field -->
    <mat-form-field
        *ngIf="showCustom"
        [appearance]="appearance"
        [ngClass]="{'field-error': hasError}"
        [ngClass]="{'disabled' : control?.disabled}"
    >
        <mat-label [ngClass]="{'input-error' : hasError}">{{ customPlaceholder }}</mat-label>
        <input
            matInput 
            autocomplete="off"
            (focus)="toggleCustomMeasurement(true)"
            (keyup)="checkInputText($event)"
            (blur)="checkInputText($event)"
            (blur)="toggleCustomMeasurement(false)"
            [type]="inputType"
            [required]="required"
            [maxLength]="maxLength"
            [placeholder]="'Enter'"
            [ngClass]="{'input-error': hasError}"
            [(ngModel)]="defaultValue"
        />
    </mat-form-field>
    <div *ngIf="showCustom && showMeasurement" class="select-field__custom-measurement">
        {{ customMeasurement }}
    </div>
    <div *ngIf="showCustom" class="select-field__custom-button">
        <button
            class="select-field__custom-interactive"
            (click)="toggleOptions()"
            (blur)="blurToggleOptions()"
        >
            <!-- Downward Purple Arrow -->
            <div 
                class="arrow" 
                [ngClass]="{
                    'arrow--error' : hasError,
                    'arrow--up' : showOptions,
                    'arrow--disabled' : disabled
                }"
            ></div>
        </button>
    </div>
    <!-- Drop Down Error Message -->
    <span class="select-field__error-msg" *ngIf="hasError">{{ errorMessage }}</span>
    <!-- Drop Down Options -->
    <ul 
        class="options"
        [ngClass]="{'options--scroll' : scroll, 'options--top' : top}"
        *ngIf="showOptions && options && options.length"
    >
        <li
            class="options--option"
            *ngFor="let option of options; let i = index"
            [class.active-option]="i == activeOptionIndex"
            (click)="selectDropOption(option)"
        >
            {{ option?.Value || option?.description }}
        </li>
    </ul>
</div>